export default {
    Unknown: {
        id: "0",
        label: 'Unknown',
        translationKey: 'unknown'
    },
    Active: {
        id: "1",
        label: 'Active',
        translationKey: 'active'
    },
    InActive: {
        id: "2",
        label: 'InActive',
        translationKey: 'inactive'
    }
};
